/**
 =========================================================
 * Soft UI Dashboard PRO React - v2.0.0
 =========================================================
 
 * Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
 * Copyright 2021 Creative Tim (https://www.creative-tim.com)
 
 Coded by www.creative-tim.com
 
 =========================================================
 */

// Core
import PropTypes from "prop-types";

// Components
import Input from "components/Atoms/Input";
import Flatpickr from "react-flatpickr";

// Styles
import "flatpickr/dist/flatpickr.css";
import "./styles.css";

function DatePicker({ input, disabled, ...rest }) {
  return (
    <Flatpickr
      {...rest}
      render={({ defaultValue }, ref) => (
        <div style={{ position: "relative", width: "100%" }}>
          <Input {...input} defaultValue={defaultValue} inputRef={ref} disabled={disabled} />
          <i
            className="material-icons"
            style={{
              position: "absolute",
              right: 10,
              top: "50%",
              transform: "translateY(-50%)",
              color: "#6c757d",
              pointerEvents: "none",
              fontSize: 20,
            }}
          >
            event
          </i>
        </div>
      )}
    />
  );
}

// Setting default values for the props of DatePicker
DatePicker.defaultProps = {
  input: {},
  disabled: false,
};

// Typechecking props for the DatePicker
DatePicker.propTypes = {
  // eslint-disable-next-line
  input: PropTypes.objectOf(PropTypes.object),
  disabled: PropTypes.bool,
};

export default DatePicker;
